import request from '@/utils/request'

export function getPackageGroupApi(query) {
  return request({
    url: '/config-service/v1/package/package-group',
    method: 'get',
    params: query
  })
}

export function getPackageGroupDetailApi({ id }) {
  return request({
    url: `/config-service/v1/package/package-group/${id}`,
    method: 'get'
  })
}

export function addPackageGroupApi(query) {
  return request({
    url: '/config-service/v1/package/package-group',
    method: 'post',
    data: query
  })
}

export function updatePackageGroupApi(query) {
  return request({
    url: '/config-service/v1/package/package-group',
    method: 'put',
    data: query
  })
}
export function deletePackageGroupApi(query) {
  return request({
    url: '/config-service/v1/package/package-group',
    method: 'delete',
    data: query
  })
}
